import common from "../../utils/common";
import c from "../../utils/constants";
import env from "../../utils/env";
import _ from "underscore";

class UserDetailsController {

  constructor($stateParams, UsersService, AppContextService, NotificationService, $scope) {
    "ngInject"

    this.usersService = UsersService;
    this.appContextService = AppContextService;
    console.log($stateParams.userId);
    this.userId = $stateParams.userId;
    this.getUserDetails(this.userId);
    this.imageBaseUrl = env.getStorageUrl() + "images/";
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.isDeletingAccount = false;
    this.requestedDeletedAccount = false;
  }

  $onInit() {
    this.tabTypes = {
      PROFILE: 1,
      PAYMENT: 2,
      JOBS_AND_RATINGS: 3,
      CERTIFICATES: 4,
      MESSAGES: 5,
      RATINGS: 6,
      TIMESHEET: 7,
    };

    this.creditAccountReasonOptions = [
        { value: c.walletTransactionReason.SPECIAL_OFFER, label: "Special Offer" },
        { value: c.walletTransactionReason.JOB_CANCELLED_BY_HELPER, label: "Job Cancelled by Helper" },
        { value: c.walletTransactionReason.ADMIN_ACTION, label: "Other" },
    ];
  }

  getUserDetails(userId) {
    this.isLoading = true;

    this.usersService.getUserDetails(userId, (response) => {
      console.log(response.data);

      this.user = response.data;
      this.isLoading = false;

      this.getTabs();

      this.$scope.$apply();
    },
    (error) => {
      this.isLoading = false;
    })
  }

  getTabs() {
    if(this.isClient()) {

      this.tabs = {
        [this.tabTypes.PROFILE]: {
          key: 1,
          label: "PROFILE",
          isActive: true,
          icon: "fa fa-user",
        },
        [this.tabTypes.PAYMENT]: {
          key: 2,
          label: "PAYMENT",
          isActive: false,
          icon: "fa fa-dollar",
        },
        // [this.tabTypes.JOBS_AND_RATINGS]: {
        //   key: 3,
        //   label: "JOBS & RATINGS",
        //   isActive: false,
        //   icon: "fa fa-user",
        // },
        [this.tabTypes.MESSAGES]: {
          key: 4,
          label: "MESSAGES",
          isActive: false,
          icon: "fa fa-envelope",
        },
        [this.tabTypes.RATINGS]: {
          key: 6,
          label: "RATINGS",
          isActive: false,
          icon: "fa fa-star",
        },
        [this.tabTypes.TIMESHEET]: {
          key: 7,
          label: "TIMESHEET",
          isActive: false,
          icon: "fa fa-clock-o",
        },
      }

    } else {

      this.tabs = {
        [this.tabTypes.PROFILE]: {
          key: 1,
          label: "PROFILE",
          isActive: true,
          icon: "fa fa-user",
        },
        [this.tabTypes.PAYMENT]: {
          key: 2,
          label: "PAYMENT",
          isActive: false,
          icon: "fa fa-dollar",
        },
        [this.tabTypes.CERTIFICATES]: {
          key: 3,
          label: "CERTIFICATES",
          isActive: false,
          icon: "fa fa-user",
        },
        [this.tabTypes.JOBS_AND_RATINGS]: {
          key: 4,
          label: "JOBS & RATINGS",
          isActive: false,
          icon: "fa fa-user",
        },
        [this.tabTypes.MESSAGES]: {
          key: 5,
          label: "MESSAGES",
          isActive: false,
          icon: "fa fa-envelope",
        },
        [this.tabTypes.TIMESHEET]: {
          key: 7,
          label: "TIMESHEET",
          isActive: false,
          icon: "fa fa-clock-o",
        },
      }

    }

    this.activeTab = this.tabs["1"];

  }

  switchTab(tab) {
    this.activeTab = tab;

    Object.keys(this.tabs).map((i) => {
      if(this.tabs[i] == this.activeTab) this.tabs[i].isActive = true;
      else this.tabs[i].isActive = false;
    })
  }

  formatDate(date) {
    return common.formatDate(date);
  }

  isClient() {
    return (this.user && this.user.entityType == c.entityType.CLIENT);
  }

  isHidden() {
    return (this.user && this.user.isHidden);
  }

  isDisabled() {
    return (this.user && this.user.isDisabled);
  }

  isProvider() {
    return (this.user && this.user.entityType == c.entityType.PROVIDER);
  }

  onRatingUpdated(totalRatingsAvg) {
    if (this.isClient()) {
      this.user.clientInfo.ratingsAvg = totalRatingsAvg;
    } else {
      this.user.providerInfo.ratingsAvg = totalRatingsAvg;
    }
  }

  loginAsUser(targetDevice) {

    this.usersService.getLoginAsUserAccessToken(this.userId,
    (response) => {
      console.log("Access token::", response.data);
      this.redirectToTarget(targetDevice, response.data.accessToken, this.user.country);
    },
    (error) => {

    });
  }

  redirectToTarget(targetDevice, token, country) {
    const rootUrl = env.getLoginAsBaseUrl(targetDevice, country);
    var url = rootUrl + `?admin_mode=1&access_token=${token}`;
    console.log(url);
    window.open(rootUrl + `?admin_mode=1&access_token=${token}`);
  }

  hasGlobalAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasGlobalAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  hasLoginAsUserAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if(this.appContextService.hasLoginAsUserAccess(appContext.roles))
      return true;
    else
      return false;
  }

  openConfirmDeleteDialog() {
    var dialog = $("#confirm-delete-dialog").data("kendoDialog");
    dialog.open();
  }

  // ****************//
  // Reset Password  //
  // ****************//
  openResetPasswordDialog() {
    this.resetPasswordValidator.hideMessages();
    this.resetPasswordDialog.open();
    this.resetPasswordDialog.bind("close", () => this.clearResetPasswordDialog());
  }

  closeResetPasswordDialog() {
    this.clearResetPasswordDialog();
    this.resetPasswordDialog.close();
  }

  clearResetPasswordDialog() {
    this.newPassword = "";
    this.repeatPassword = "";
    this.passwordsDoNotMatch = false;

    this.resetPasswordDialog.unbind("close", this.closeResetPasswordDialog.bind(this));
  }

  resetPassword() {
    this.passwordsDoNotMatch = false;

    if(!this.resetPasswordValidator.validate())
      return;

    if(this.newPassword != this.repeatPassword) {
      this.passwordsDoNotMatch = true;
      return;
    }

    let payload = {
      newPassword: this.newPassword,
      confirmPassword: this.repeatPassword
    }

    this.usersService.resetPassword(this.userId, payload, () => {
      this.closeResetPasswordDialog();
    }, () => {
      this.closeResetPasswordDialog();
    });
  }

  // ****************//


  // ****************//
  // Credit Account  //
  // ****************//

  openCreditAccountDialog() {
    this.creditAccountValidator.hideMessages();
    this.creditAccountDialog.open();
    this.creditAccountDialog.bind("close", this.clearCreditAccountDialog.bind(this));
  }

  closeCreditAccountDialog() {
    this.clearCreditAccountDialog();
    this.creditAccountDialog.close();
  }

  clearCreditAccountDialog() {
    this.creditAccountReason = undefined;
    this.creditAccountAmount = undefined;

    this.creditAccountDialog.unbind("close", this.clearCreditAccountDialog.bind(this));
  }

  creditAccount(e) {
    if(!this.creditAccountValidator.validate())
      return;

    let payload = {
      actionType: c.adminEntitiesActionType.CREDIT_ACCOUNT_BALANCE,
      transactionReason: this.creditAccountReason,
      transactionAmount: this.creditAccountAmount * 100
    }
    this.usersService.updateUserDetails(this.userId, payload, () => {
      this.closeCreditAccountDialog();
    }, () => {
      this.closeCreditAccountDialog();
    });
  }

  // ****************//

  handleDisableAccountDialog() {
    const message = "Are you sure you want to disable this account?";
    if (confirm(message)) {
      this.usersService.disableAccount(this.userId, () => {
        this.user.isDisabled = true;
        alert("This account has been disabled, please allow a few minutes for Bigfoot to update its cache.");
       }, (err) => {
        alert(err.data);
      });
    }
  }

  handleReactivateAccountDialog() {
    const message = "Are you sure you want to want to reactivate this account?";
    if (confirm(message)) {
      this.usersService.reactivateAccount(this.userId, () => {
        this.user.isDisabled = false;
        alert("This account has been reactivated, please allow a few minutes for Bigfoot to update its cache.");
       }, (err) => {
        alert(err.data);
      });
    }
  }

  handleDeleteAccount() {
    const message = "Are you sure you want to delete this account? THIS ACTION IS IRREVERSIBLE.";
    if (confirm(message)) {
      this.isDeletingAccount = true;
      this.usersService.deleteUser(this.userId, () => {
        this.isDeletingAccount = false;
        alert("This account has been deleted successfully. Please close this window.");
        // window.close();
       }, (err) => {
        this.isDeletingAccount = false;
        alert(err.data);
      });
    }
  }

  deleteUser(e) {
    let payload = { deleteIntercomAccount: this.deleteIntercomAccount }
    this.usersService.deleteUser(this.userId, payload, () => { }, () => { });
  }

  getConfirmDeleteDialogOptions() {
    var options = {
      title: "Are you sure?",
      close: () => {
        this.deleteIntercomAccount = true;
      },
      actions: [
          { text: 'No' },
          {
            text: 'Yes',
            primary: true,
            action: (e) => this.deleteUser(e)
          }
      ],
    };

    return _.extend(options, this._getDialogOptions());
  }

  getResetPasswordOptions() {
    var options = {
      title: "Reset Password",
      width: "550px",
    };

    return _.extend(options, this._getDialogOptions());
  }

  getCreditAccountDialogOptions() {
    var options = {
      title: "Credit Account",
      width: "550px",
    };

    return _.extend(options, this._getDialogOptions());
  }

  _getDialogOptions() {
    return {
      buttonLayout: "normal",
      messages:{
        close: ""
      },
      visible: false,
      closable: true,
      modal: true,
    };
  }

  handleRefreshCache() {
    let payload = { actionType: c.adminEntitiesActionType.REFRESH_CACHE }
    this.usersService.updateUserDetails(this.userId, payload, () => {
      this.notificationService.success("Cache refresh successful.");
    }, () => {
      this.notificationService.error("Cache refresh failed.");
    });
  }

}

export default UserDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/user-details/user-details.controller.js
 **/